var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCareGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9736 5.93365L14.4736 1.26699C14.3245 1.20073 14.1632 1.1665 14 1.1665C13.8368 1.1665 13.6754 1.20073 13.5263 1.26699L3.02631 5.93365C2.82002 6.0253 2.64475 6.17482 2.52175 6.36409C2.39874 6.55336 2.33328 6.77425 2.33331 6.99999V7.81665C2.3345 11.6651 3.36426 15.4433 5.31599 18.7601C7.26772 22.0769 10.0705 24.8118 13.4341 26.6817C13.6073 26.7777 13.802 26.8281 14 26.8281C14.198 26.8281 14.3927 26.7777 14.5658 26.6817C17.9295 24.8118 20.7322 22.0769 22.684 18.7601C24.6357 15.4433 25.6655 11.6651 25.6666 7.81665V6.99999C25.6667 6.77425 25.6012 6.55336 25.4782 6.36409C25.3552 6.17482 25.1799 6.0253 24.9736 5.93365ZM23.3333 7.81665C23.3323 11.138 22.4723 14.4026 20.8369 17.2933C19.2015 20.1841 16.8463 22.6028 14 24.3145C11.1537 22.6028 8.79846 20.1841 7.16306 17.2933C5.52765 14.4026 4.66767 11.138 4.66665 7.81665V7.75832L14 3.60965L23.3333 7.75832V7.81665ZM12.8333 11.6667H15.1666V21H12.8333V11.6667ZM12.8333 6.99999H15.1666V9.33332H12.8333V6.99999Z",
    fill: "#ABD373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareGreen);
export default __webpack_public_path__ + "static/media/careGreen.fccc374fd892700db8c77e4e4e7d2393.svg";
export { ForwardRef as ReactComponent };